module.exports = __webpack_public_path__ + "static/img/title1.dc6477f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/title1.jpg
// module id = I5iS
// module chunks = 0